module.exports = __webpack_public_path__ + "img/blue-mail-envelope-open.b4cd879d.svg";